export default class EventHook {
  constructor (type, name) {
    this._type = type
    this._name = name
  }

  type () {
    return this._type
  }

  name () {
    return this._name
  }

  /**
   * Function body to run, should return a promise.
   * Different hook event types (start, end etc) may
   * override different run args
   */
  run () {
    return Promise.reject(new Error('Override event hook run()'))
  }
}
